import useValidationsRegister from './use-validations-register';
export default useValidationsRegister;
